/* eslint-disable no-unused-vars */
import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import { formatPhoneForServer } from '../helpers/phone';

export const ActivePatientContext = createContext({});

function ActivePatientProvider({ children }) {
  const [patientUuid, setPatientUuid] = useState();
  const [patientInfo, _setPatientInfo] = useState();

  const setPatientInfo = (newPatientInfo) => {
    const formattedPhone = formatPhoneForServer(newPatientInfo?.phone);
    _setPatientInfo({
      ...newPatientInfo,
      phone: formattedPhone,
    });
  }

  const value = {
    patientUuid,
    patientInfo,
    setPatientUuid,
    setPatientInfo,
  };

  return (
    <ActivePatientContext.Provider value={value}>
      {children}
    </ActivePatientContext.Provider>
  );
}

ActivePatientProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ActivePatientProvider;
